import { ICity } from '@/api/cities/types/cities-types'
import { cn } from '@/utils/styles/cn'

interface IMapLabelProps {
    label: ICity['label'] | null
    className?: string
}

export const MapLabel = ({ label, className }: IMapLabelProps) => {
    if (!label) return null

    return (
        <div
            className={cn(
                `rounded-full w-fit capitalize px-3 min-h-6 max-h-7 text-[12px] flex items-center leading-0
                font-semibold`,
                label === 'NEW' ? 'bg-black text-white' : 'bg-[#FBE888] text-black',
                className
            )}
        >
            <span>{label}</span>
        </div>
    )
}
